<template>
  <d-container fluid class="main-content-container px-4">
    <d-row>
      <d-col lg="8" class="mx-auto mt-4">
        <d-card class="card-small edit-user-details mb-4">
          <d-card-body class="p-0" v-if="loadingBank">
            <loader :is-loading="loadingBank"></loader>
          </d-card-body>

          <d-card-body class="p-0" v-else>
            <d-form class="py-0">
              <d-form-row class="mx-4">
                <ValidationObserver
                  tag="form"
                  class="container-fluid h-100"
                  ref="BankInfoValidationForm"
                >
                  <h5 class="card-title mt-5">Dados Bancários</h5>
                  <hr />

                  <d-form-row>
                    <!-- AccountType -->
                    <d-col md="6" class="form-group">
                      <label for="selectAccType">Tipo de conta</label>
                      <ValidationProvider rules="required" v-slot="{errors, invalid}">
                        <d-select v-model="BankData.AccountType.Code" id="selectAccType">
                          <option :value="null">Selecione</option>
                          <option :value="'CC'">Conta Corrente</option>
                          <option :value="'PP'">Conta Poupança</option>
                        </d-select>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedBankData"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </d-col>
                    <!-- Bank Code -->
                    <d-col md="6" class="form-group">
                      <label for="selectBank">Banco</label>
                      <ValidationProvider rules="required" v-slot="{errors, invalid}">
                        <d-select v-model="BankData.Bank.Code" id="selectBank">
                          <option :value="null">Selecione</option>
                          <option
                            v-for="(bank,i) in BankList"
                            :key="i"
                            :value="bank.Code"
                          >{{bank.Code}} - {{bank.Name}}</option>
                        </d-select>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedBankData"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>

                  <d-form-row>
                    <d-col md="3">
                      <div class="form-group">
                        <label for="inputAgency">Agência</label>
                        <ValidationProvider rules="required" v-slot="{errors, invalid}">
                          <d-input
                            v-model="BankData.BankAgency"
                            :class="validatedBankData | showValidateError(invalid)"
                            id="inputAgency"
                          />
                          <div
                            class="invalid-feedback d-block"
                            v-if="validatedBankData"
                          >{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </d-col>
                    <!-- BankAgencyDigit -->
                    <d-col md="3">
                      <div class="form-group">
                        <label for="inputAgencyDigit">Dígito</label>
                        <d-input v-model="BankData.BankAgencyDigit" id="inputAgencyDigit" />
                      </div>
                    </d-col>
                    <!-- BankAccount -->
                    <d-col md="3" class="form-group">
                      <label for="inputBankAcc">Conta</label>
                      <ValidationProvider rules="required" v-slot="{errors, invalid}">
                        <d-input
                          v-model="BankData.BankAccount"
                          :class="validatedBankData | showValidateError(invalid)"
                          id="inputBankAcc"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedBankData"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </d-col>
                    <!-- BankAccountDigit -->
                    <d-col md="3" class="form-group">
                      <label for="inputBankAccDigit">Dígito</label>
                      <d-input v-model="BankData.BankAccountDigit" id="inputBankAccDigit" />
                    </d-col>
                  </d-form-row>
                  <!-- ConfirmationVeracity -->
                  <d-form-row class="mt-4">
                    <d-col md="12" class="form-group">
                      <ValidationProvider
                        :rules="{ required: { allowFalse: false } }"
                        v-slot="{errors, invalid}"
                      >
                        <d-checkbox
                          id="checkConfirm"
                          v-model="confirmVeracity"
                        >Confirmo que os dados acima são do titular da conta</d-checkbox>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedBankData"
                        >{{ errors[0] ? 'Por favor, confirme a veracidade dos dados informados' : '' }}</div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>
                </ValidationObserver>
              </d-form-row>
            </d-form>
          </d-card-body>
          <!-- Save Changes -->
          <d-card-footer class="border-top">
            <div class="float-right">
              <b-button
                size="sm"
                v-on:click.stop="InsertUpdateBankData($event)"
                :disabled="loading || loadingBank"
                class="mr-2 btn-accent"
              >
                <template v-if="!loading">Salvar</template>
                <template v-else>
                  <loader :small="true" :isLoading="loading"></loader>
                </template>
              </b-button>
            </div>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: "bank",
  data: function() {
    return {
      BankList: [],
      loading: false,
      loadingBank: false,
      BankData: {
        Bank: {
          Code: ""
        },
        AccountType: {
          Code: ""
        },
        BankAgency: "",
        BankAgencyDigit: "",
        BankAccount: "",
        BankAccountDigit: ""
      },
      confirmVeracity: false,
      validatedBankData: false
    };
  },
  mounted() {
    this.GetBanks();
    this.GetBankData();
  },
  methods: {
    GetBankData: function() {
      this.loadingBank = true;
      let self = this;
      this.$store
        .dispatch("GetBankData", null)
        .then(
          response => {
            if (response.BankData != undefined && response.BankData != null) {
              self.BankData = response.BankData;
            }
          },
          error => {
            this.$makeToast(
              "Não foi possível buscar os dados bancários",
              'danger',
              "Dados bancários",
              error
            );
          }
        )
        .finally(() => {
          this.loadingBank = false;
        });
    },
    GetBanks: function() {
      this.$store
        .dispatch("GetBanks")
        .then(response => {
          this.BankList = response;
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível carregar a lista de bancos, tente novamente.",
            'danger',
            "Falha ao obter a lista de bancos",
            error
          );
        });
    },
    InsertUpdateBankData: function(e) {
      e.preventDefault();
      this.validatedBankData = true;

      this.$refs.BankInfoValidationForm.validate().then(isValid => {
        if (isValid) {
          this.validatedBankData = false;
          this.loading = true;

          this.$store
            .dispatch("InsertUpdateBankData", { BankData: this.BankData })
            .then(res => {
              if (res == true) {
                this.$makeToast(
                  "Os dados foram alterados.",
                  "success",
                  "Dados bancários"
                );
              }
            })
            .catch(error => {
              this.$makeToast(
                "Não foi possível alterar os dados bancários.",
                'danger',
                "Dados bancários",
                error
              );
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/bank.vue